import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Virtual Ticket Messages',
  attributeName: 'virtualTicketMessages',
  helpText: 'This section specifies the messages of virtual ticket validation code API response. In case of success or error.',
  fields: [
    {
      attributeName: 'virtualTicketTransactionSuccess',
      helpText: 'Success text response when the virtual ticket validation code API is done. You can include the number of uses with $1 param and the limit of uses with $2.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Success message',
      placeholder: 'Write a success prompt text...',
      default: '',
    },
    {
      attributeName: 'virtualTicketCodeNotFound',
      helpText: "Error text response when the virtual ticket validation code API responses that the code doesn't exist.",
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Code not found messsage',
      placeholder: 'Write a code not found prompt text...',
      default: '',
    },
    {
      attributeName: 'virtualTicketCodeUsed',
      helpText: 'Error text response when the virtual ticket validation code API responses that the code exceeds the number of uses.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Code used text',
      placeholder: 'Write a code used prompt text...',
      default: '',
    },
  ],
};
